import { IModel } from '@/@types/models/model';
import coreFields from './helpers/coreFields';
import buttonFields from './helpers/buttonFields';
// import commonFields from './helpers/commonFields';

const Koncesija: IModel = {
  title: 'Koncesije',
  apiPath: 'koncesije',
  layer: 'koncesije',
  forms: {
    default: {
      fields: [
        // 'geom',
        // 'broj_polja',
        'polje',
        'zona',
        'osoba',
        'obrt_firma',
        // 'broj_koncesionara',
        'adresa',
        'sluzbeni_g',
        'external_id',
        // 'broj_id',
        'kontakt',
        'oib',
        'datum_ugovora',
        'zavrsetak',
        'uzgoj_id',
        'povrsina',
        'volumen',
        'prosjecna_dubina'
      ],
    },
    insert: {
      fields: [
        // 'geom',
        // 'broj_polja',
        'polje',
        'zona',
        'osoba',
        'obrt_firma',
        // 'broj_koncesionara',
        'adresa',
        'sluzbeni_g',
        'external_id',
        // 'broj_id',
        'kontakt',
        'oib',
        'datum_ugovora',
        'zavrsetak',
        'uzgoj_id',
        'povrsina',
      ],
      layout: [
        { 
          title: 'koncesije:sections.koncesija'
          , columns: 3
          , fieldNames: ['polje', 'zona', 'uzgoj_id', 'povrsina']
        }, 
        {
          title: 'koncesije:sections.koncesionar'
          , columns: 3
          , fieldNames: ['oib', 'osoba', 'obrt_firma', 'adresa', 'kontakt']
        }, 
        {
          title: 'koncesije:sections.ugovor'
          , columns: 3
          , fieldNames: ['datum_ugovora', 'zavrsetak', 'sluzbeni_g', 'external_id']
        }
      ]
    },
    update: {
      fields: [
        // 'geom',
        // 'broj_polja',
        'polje',
        'zona',
        'osoba',
        'obrt_firma',
        // 'broj_koncesionara',
        'adresa',
        'sluzbeni_g',
        'external_id',
        // 'broj_id',
        'kontakt',
        'oib',
        'datum_ugovora',
        'zavrsetak',
        'uzgoj_id',
        'povrsina',
      ],
      layout: [
        { 
          title: 'koncesije:sections.koncesija'
          , columns: 3
          , fieldNames: ['polje', 'zona', 'uzgoj_id', 'povrsina']
        }, 
        {
          title: 'koncesije:sections.koncesionar'
          , columns: 3
          , fieldNames: ['oib', 'osoba', 'obrt_firma', 'adresa', 'kontakt']
        }, 
        {
          title: 'koncesije:sections.ugovor'
          , columns: 3
          , fieldNames: ['datum_ugovora', 'zavrsetak', 'sluzbeni_g', 'external_id']
        } 
      ]
    },
    map: {
      fields: ['geom', 
        // { source: 'wkt', width: 'full', readonly: false, tooltip: 'tooltips.coords_trs' }
      ],
    },
    mapNoEdit: {
      fields: ['geom', 
        // { source: 'wkt', width: 'full', tooltip: 'tooltips.coords_trs' }
      ],
    },
  },

  listViews: {
    default: {
      fields: [
        'id',
        // 'gid',
        // 'broj_polja',
        'polje',
        'zona',
        'uzgoj_id',
        'povrsina',
        'volumen_str',
        'prosjecna_dubina',
        // 'broj_koncesionara',
        'oib',
        'osoba',
        'obrt_firma',
        'adresa',
        'kontakt',
        // 'broj_id',
        'datum_ugovora',
        'zavrsetak',
        'sluzbeni_g',
        'external_id',
        // 'geom',
        'active',
        'docs',
        'btn_show_history',
        // 'created_on',
        // 'created_by',
        // 'modified_on',
        // 'modified_by',
      ],
    },
    history: {
      fields: [
        'id',
        // 'gid',
        // 'broj_polja',
        'polje',
        'zona',
        'uzgoj_id',
        'povrsina',
        // 'broj_koncesionara',
        'oib',
        'osoba',
        'obrt_firma',
        'adresa',
        'kontakt',
        // 'broj_id',
        'datum_ugovora',
        'zavrsetak',
        'sluzbeni_g',
        'external_id',
        // 'geom',
        // 'active',
        'valid_from',
        'valid_to',
        // 'created_on',
        // 'created_by',
        // 'modified_on',
        // 'modified_by',
      ],
    },
  },
  fields: [
    coreFields.id,
    coreFields.gid,
    coreFields.created_on,
    coreFields.created_by,
    coreFields.modified_on,
    coreFields.modified_by,
    {
      ttoken: 'is_geom_changed',
      title: 'is_geom_changed',
      type: 'boolean',
      source: 'is_geom_changed',
    },
    {
      ttoken: 'koncesije:koncesije.broj_polja',
      title: 'broj_polja',
      source: 'broj_polja',
      type: 'numeric',
      filter: true,
    },
    {
      ttoken: 'koncesije:koncesije.polje',
      title: 'polje',
      source: 'polje',
      type: 'text',
      filter: true,
    },
    {
      ttoken: 'koncesije:koncesije.zona',
      title: 'zona',
      source: 'zona',
      type: 'numeric',
      filter: true,
    },
    {
      ttoken: 'koncesije:koncesije.povrsina',
      title: 'povrsina',
      source: 'povrsina',
      type: 'numeric',
      suffix: 'm²',
      tooltip: 'tooltips.povrsina_from_geom',
      readonly: true,
      filter: true,
      width: 'full'
    },
    {
      ttoken: 'koncesije:koncesije.volumen',
      title: 'volumen_str',
      source: 'volumen_str',
      type: 'text',
      suffix: 'm³',
      readonly: true,
      filter: true,
      width: 'full'
    },
    {
      ttoken: 'koncesije:koncesije.prosjecna_dubina',
      title: 'prosjecna_dubina',
      source: 'prosjecna_dubina',
      type: 'numeric',
      suffix: 'm',
      readonly: true,
      filter: true,
      width: 'full'
    },
    {
      ttoken: 'koncesije:koncesije.osoba',
      title: 'osoba',
      source: 'osoba',
      type: 'text',
      filter: true,
    },
    {
      ttoken: 'koncesije:koncesije.obrt_firma',
      title: 'obrt_firma',
      source: 'obrt_firma',
      type: 'text',
      filter: true,
    },
    {
      ttoken: 'koncesije:koncesije.broj_koncesionara',
      title: 'broj_koncesionara',
      source: 'broj_koncesionara',
      type: 'numeric',
      filter: true,
    },
    {
      ttoken: 'koncesije:koncesije.adresa',
      title: 'adresa',
      source: 'adresa',
      type: 'text',
      filter: true,
    },
    {
      ttoken: 'koncesije:koncesije.sluzbeni_g',
      title: 'sluzbeni_g',
      source: 'sluzbeni_g',
      type: 'text',
      filter: true,
    },
    {
      ttoken: 'koncesije:koncesije.external_id',
      title: 'external_id',
      source: 'external_id',
      type: 'numeric',
      filter: true,
    },
    {
      ttoken: 'koncesije:koncesije.broj_id',
      title: 'broj_id',
      source: 'broj_id',
      type: 'numeric',
      filter: true,
    },
    {
      ttoken: 'koncesije:koncesije.external_id',
      title: 'external_id',
      source: 'external_id',
      type: 'numeric',
      filter: true,
    },
    {
      ttoken: 'koncesije:koncesije.kontakt',
      title: 'kontakt',
      source: 'kontakt',
      type: 'text',
      filter: true,
    },
    {
      title: 'OIB',
      source: 'oib',
      ttoken: 'common.oib',
      type: 'text',
      validation: {
        required: false,
        minLength: 11,
        maxLength: 11,
        regex: 'oib',
      },
      export: {
        width: 20,
      },
    },
    {
      ttoken: 'koncesije:koncesije.datum_ugovora',

      title: 'datum_ugovora',
      source: 'datum_ugovora',
      type: 'date',
      filter: true,
    },
    {
      ttoken: 'koncesije:koncesije.zavrsetak',
      title: 'zavrsetak',
      source: 'zavrsetak',
      type: 'date',
      filter: true,
    },
    {
      ttoken: 'koncesije:koncesije.uzgoj_id',
      title: 'uzgoj_id',
      source: 'uzgoj_id',
      type: 'picker',
      items: {
        labels: ['ribe', 'školjke', 'prihvat mlađi školjaka'],
        values: [1, 2, 3],
      },
      validation: {
        // required: true,
      },
      filter: true,
    },
    {
      ttoken: 'koncesije:koncesije.valid_from',
      title: 'Važi od',
      type: 'datetime',
      source: 'valid_from',
      readonly: true,
      filter: true,
    },
    {
      ttoken: 'koncesije:koncesije.valid_to',
      title: 'Važi do',
      type: 'datetime',
      source: 'valid_to',
      readonly: true,
      filter: true,
    },
    {
      type: 'boolean',
      source: 'is_newest',
      title: 'flag najnoviji',
      ttoken: 'koncesije:koncesije.is_newest',
    },
    {
      type: 'boolean',
      source: 'is_deleted',
      title: 'flag deleted',
      ttoken: 'koncesije:koncesije.is_deleted',
    },
    {
      type: 'boolean',
      source: 'has_history',
      title: 'has history',
      ttoken: 'koncesije:koncesije.has_history',
    },
    // { ttoken: 'koncesije:koncesije.uzgoj', title: 'uzgoj', source: 'uzgoj', type: 'text', readonly: true },
    coreFields.geom,
    coreFields.docs,
    // commonFields.wkt,
    coreFields.active,
    buttonFields.show_history,
  ],
};

export default Koncesija;
